<template>
    <div class="achievment-box">
        <section-title main="我们过去取得的成就" sub="未来,更期待与机构一起推动中国的教育进步"></section-title>
        <div class="content">
            <div class="content-item" v-for="(item, index) in objData" :key="index">
                <img class="info-img" :src="item.img">
                <p class="des">{{item.des}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { achieveList } from '@/const'
export default {
    data () {
        return {
            objData: achieveList
        }
    }
}
</script>
<style lang="scss" scoped>
.achievment-box{
    padding: 0px 20px;
    .content{
        .content-item{
            width: 100%;
            text-align: left;
            margin-bottom: 24px;
            .info-img{
                width: 100%;
            }
            .des{
                font-size:12px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color : #000000;
                line-height:17px;
                margin-top: 9px;
            }
            &:last-of-type{
                margin-bottom: 0px;
            }
        }
    }
}
</style>